<script>
import Layout from "@/router/layouts/store";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Cart': 'Carrinho',
    },
    es: {
      'Cart': 'Cesta',
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      carts: {
      },
    };
  },
  methods: {
    getCarts() {
      api
        .get('store/carts')
        .then(response => {
          if (response.data.status == 'success') {
            this.carts = response.data.list
          }
        })
    },
  },
  computed: {
  },
  mounted() {
    this.getCarts()
  }
};
</script>

<template>
  <Layout ref="store">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/store">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/store">Loja Virtual</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Carrinho</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!carts" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="carts && carts.length == 0">
      <div class="card">
        <div class="card-body text-center">
          Nenhum carrinho encontrado.
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-md-6 col-xl-4" v-for="(row, id) in carts" :key="id">
          <router-link class="text-dark" tag="a" :to="'/store/carts/' + row.partner.id">
            <div class="card card-partner">
              <div class="card-body p-2 d-flex align-items-center">
                <div class="logo">
                  <img :src="row.partner.logo">
                </div>
                <div>
                  <h5 class="mb-0">{{ row.partner.name }}</h5>
                </div>
                <div class="flex-fill text-right px-3">
                  <h4 class="m-0 py-1" style="line-height: 15px;">
                    {{ row.items }}<br>
                    <small class="font-size-14">items</small>
                  </h4>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.card-partner .d-flex {
  gap: 10px;
}

.card-partner .logo img {
  border-radius: 50%;
  width: 100px;
}
</style>
